/*
Author : Raphaël Dardeau


Markup :

<a href="" data-popin="auth.html" data-popin-class="popin popin--h" data-popin-condition="body:not(.is-loggedIn)">
    connection
</a>


Setup :

var popin;
$(function() {
	popin = $(document).popin({
		transitionDuration:200,
		tplPopinHead:'<a href="#" class="js-popin-close"></a>'
	});

	// if you have to launch the popin via JavaScript
	popin.setPopin({
		"url":"auth.html",
		"classname":"popin popin--h"
	});
});
*/
;(function ( $, window, document, undefined ) {
    var pluginName = "popin",
        defaults = {
			tplPopin: '<div class="js-popin popin"></div>',
			tplPopinHead: '',
			tplPopinFoot: '',
			tplFog: '<div class="js-fog fog"></div>',
			transitionDuration:0,
			locked: false,
			callback: function() {}
		};

    function Plugin( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {

        init: function() {
			if (!$(".js-popin").length)
				$("body").append(this.settings.tplPopin);
			this.setElements();
			this.setEvents();
        },

        setElements: function() {
			this.$document = $(document);
			this.$body = $("body");
			this.$popin = $(".js-popin");
		},

		setEvents: function() {
			this.$document.on("click", "*[data-popin]", $.proxy(function (e) {
				this.$trigger = $(e.currentTarget);
				var condition = this.$trigger.attr("data-popin-condition") ? this.$trigger.data("popin-condition") : "";
				if (!condition || $(condition).length) {
					var url = this.$trigger.data("popin");
					var classname = this.$trigger.attr("data-popin-class") ? this.$trigger.data("popin-class") : "";
					var locked = this.$trigger.attr("data-popin-locked") ? this.$trigger.attr("data-popin-locked") : false;
					var params = {
						"url": url,
						"classname": classname,
						"globalClassname": "is-poping",
						"locked": locked,
						"callback": this.settings.callback
					}
					this.setPopin(params);
					e.preventDefault();
				}
			}, this));
			this.$document.on("click", ".js-fog, .js-popin-close", $.proxy(this.unsetPopin, this));
		},

		setPopin: function(params) {
			if (!$(".js-fog").length)
				this.$body.append(this.settings.tplFog);
			if (params.globalClassname)
				this.$body.addClass(params.globalClassname);
			else
				this.$body.addClass("is-poping");
			this.$popin.addClass("is-loading");
			var tplPopinHead = (params.tplPopinHead) ? params.tplPopinHead : this.settings.tplPopinHead;
			var tplPopinFoot = (params.tplPopinFoot) ? params.tplPopinFoot : this.settings.tplPopinFoot;
			if (params.url) {
				$.get(params.url, $.proxy(function (html) {
					this.$popin.attr("class", "js-popin "+ params.classname);
					setTimeout($.proxy(function() {
						this.$popin.html(tplPopinHead + html + tplPopinFoot);
						this.$popin.trigger("popin-ready");
						if (params.globalClassname != "is-toasting")
							this.$body.removeClass("is-toasting");
						if (params.callback)
							params.callback();
					}, this), this.settings.transitionDuration);
				}, this)).fail($.proxy(function () {
					this.unsetPopin();
				}, this));
			} else if (params.html) {
				this.$popin.attr("class", "js-popin "+ params.classname).html(tplPopinHead + params.html + tplPopinFoot);
				this.$popin.trigger("popin-ready");
				if (params.globalClassname != "is-toasting")
					this.$body.removeClass("is-toasting");
				if (params.callback)
					params.callback();
			}
			if (params.locked)
				this.lockPopin();
		},

		unsetPopin: function(e) {
			if (this.$popin) {
				if (!this.locked) {
	                this.$body.removeClass("is-poping is-toasting");
	                setTimeout($.proxy(function() {
						this.$popin.empty();
                        this.$popin.trigger("popin-unload");
	                }, this), this.settings.transitionDuration);
				} else  {
					document.location.href = '/';
				}
				if (e)
	            	e.preventDefault();
        	}
		},

		lockPopin: function(e) {
			$("html").addClass("is-locked");
			this.locked = true;
		},

		unlockPopin: function(e) {
			$("html").removeClass("is-locked");
			this.locked = false;
		}

    });

    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                new Plugin( this, options ));
            }
        });
    };

})( jQuery, window, document );
